import React from 'react';

const HealthMetric = ({ label, value, tone = 'default' }) => (
  <div className={`health-metric health-metric--${tone}`}>
    <span className="health-metric__label">{label}</span>
    <span className="health-metric__value">{value}</span>
  </div>
);

const NetworkHealthCard = ({ health }) => {
  if (!health) return null;
  const { summary } = health;
  return (
    <div className="network-health-card">
      <header>
        <h2>Network Health Index</h2>
        <span className="network-health-card__score">{health.score}</span>
      </header>
      <div className="network-health-card__metrics">
        <HealthMetric label="Active (<30d)" value={summary.activeMembers} tone="success" />
        <HealthMetric label="Role Mix" value={summary.roleScore} tone="info" />
        <HealthMetric
          label="Conflict Flags"
          value={summary.conflicts}
          tone={summary.conflicts > 0 ? 'warning' : 'default'}
        />
        <HealthMetric label="Members" value={summary.totalMembers} />
        <HealthMetric label="Penalty" value={summary.conflictPenalty} tone="warning" />
      </div>
      <p className="network-health-card__hint">
        Score is +1 per active connection (up to 10) + distinct roles (up to 5) − conflict flags (up to 3).
      </p>
    </div>
  );
};

export default NetworkHealthCard;
